import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-711d8cc1")

_pushScopeId("data-v-711d8cc1")
const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center p-jc-between" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_6 = {
  class: "p-mr-2",
  "data-test": "value-body"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_9 = {
  class: "p-mr-2",
  "data-test": "description-body"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.listIsInvalid)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "p-text-center p-m-4",
          severity: "warn",
          closable: false
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.lovsManagement.fixedListInvalidError')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_DataTable, {
      value: _ctx.values,
      class: "p-datatable-sm kn-table p-m-5",
      editMode: "cell",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.lovsManagementFixedLovsTableDescriptor.globalFilterFields,
      responsiveLayout: "stack",
      breakpoint: "960px",
      onRowReorder: _ctx.setPositionOnReorder,
      onCellEditComplete: _ctx.onCellEditComplete,
      "data-test": "values-list"
    }, {
      empty: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      loading: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
      ]),
      header: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                type: "text",
                placeholder: _ctx.$t('common.search'),
                "data-test": "filter-input"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode(_component_Button, {
              id: "add-fixed-value-button",
              class: "kn-button kn-button--primary",
              label: _ctx.$t('managers.lovsManagement.add'),
              onClick: _ctx.addFixedValue,
              "data-test": "new-button"
            }, null, 8, ["label", "onClick"])
          ])
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_Column, {
          rowReorder: true,
          headerStyle: _ctx.lovsManagementFixedLovsTableDescriptor.table.reorderColumn.headerStyle,
          reorderableColumn: false
        }, null, 8, ["headerStyle"]),
        _createVNode(_component_Column, {
          class: "kn-truncated p-mr-2",
          style: _ctx.lovsManagementFixedLovsTableDescriptor.table.inputColumnStyle,
          field: "VALUE",
          header: _ctx.$t('managers.lovsManagement.value')
        }, {
          editor: _withId((slotProps) => [
            _createVNode(_component_InputText, {
              class: "p-mr-2",
              type: "text",
              modelValue: slotProps.data[slotProps.column.props.field],
              "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
              modelModifiers: { trim: true },
              maxLength: "20",
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('touched'))),
              "data-test": "value-input"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_5
          ]),
          body: _withId((slotProps) => [
            _createVNode("span", _hoisted_6, _toDisplayString(slotProps.data.VALUE), 1),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["style", "header"]),
        _createVNode(_component_Column, {
          class: "kn-truncated",
          style: _ctx.lovsManagementFixedLovsTableDescriptor.table.textAreaColumnStyle,
          field: "DESCRIPTION",
          header: _ctx.$t('managers.lovsManagement.description')
        }, {
          editor: _withId((slotProps) => [
            _createVNode(_component_Textarea, {
              class: "p-mr-2",
              type: "text",
              modelValue: slotProps.data[slotProps.column.props.field],
              "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
              modelModifiers: { trim: true },
              maxLength: "160",
              rows: "2",
              cols: "80",
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
              "data-test": "description-input"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_8
          ]),
          body: _withId((slotProps) => [
            _createVNode("span", _hoisted_9, _toDisplayString(slotProps.data.DESCRIPTION), 1),
            _hoisted_10
          ]),
          _: 1
        }, 8, ["style", "header"]),
        _createVNode(_component_Column, {
          style: _ctx.lovsManagementFixedLovsTableDescriptor.table.iconColumn.style
        }, {
          body: _withId((slotProps) => [
            _createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.deleteValueConfirm(slotProps.index)),
              "data-test": 'delete-button-' + slotProps.index
            }, null, 8, ["onClick", "data-test"])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields", "onRowReorder", "onCellEditComplete"])
  ]))
})